import React from 'react';
import { LoginForm } from '../components';

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;
